import React from "react";
import { AutoComplete } from "@fidget/common/components/form/autoComplete/autoComplete";

interface Props {
  onClick(): void;
  text: string;
  className?: string;
}

export const PlaceholderDropdown = ({ onClick, text, className }: Props) => {
  return (
    <div onClick={onClick} className={className}>
      <AutoComplete
        itemsProvider={() => []}
        itemToString={() => text}
        isOpen={false}
        overrideInputArrowIsOpen
        readOnly
      />
    </div>
  );
};
